import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
import tinycolor from 'tinycolor2';

const bp = createBreakpoints({});
const makeTheme = THEME => ({
  palette: {
    primary: {
      main: THEME.primary,
      gradient: THEME.primaryGradient,
      light: THEME.primaryLight,
      contrast: THEME.primaryContrast,
      dark: tinycolor(THEME.primary).darken(THEME.darkenRate).toHexString(),
      selected: THEME.selected,
    },
    secondary: {
      main: THEME.secondary,
      light: THEME.secondaryLight,
      dark: tinycolor(THEME.secondary).darken(THEME.darkenRate).toHexString(),
      contrast: THEME.secondaryContrast,
    },
    hover: {
      primary: {
        main: THEME.primary,
      },
      secondary: {
        main: THEME.hoverSecondary,
        contrast: THEME.hoverSecondaryContrast,
      },
      light: {
        main: THEME.hoverLight,
      },
    },
    border: {
      main: THEME.borderColor,
      secondary: THEME.textSecondary,
      darkOnly: THEME.darkOnlyBorder,
      light: tinycolor(THEME.borderColor).lighten(THEME.lightenRate).toHexString(),
    },
    warning: {
      main: THEME.warning,
      light: tinycolor(THEME.warning).lighten(THEME.lightenRate).toHexString(),
      dark: tinycolor(THEME.warning).darken(THEME.darkenRate).toHexString(),
    },
    success: {
      main: THEME.success,
      light: tinycolor(THEME.success).lighten(THEME.lightenRate).toHexString(),
      dark: tinycolor(THEME.success).darken(THEME.darkenRate).toHexString(),
    },
    info: {
      main: THEME.info,
      light: tinycolor(THEME.info).lighten(THEME.lightenRate).toHexString(),
      dark: tinycolor(THEME.info).darken(THEME.darkenRate).toHexString(),
    },
    // point 4
    error: {
      main: THEME.error,
      light: tinycolor(THEME.error).lighten(THEME.lightenRate).toHexString(),
      dark: tinycolor(THEME.error).darken(THEME.darkenRate).toHexString(),
    },
    background: {
      default: THEME.background,
      paper: tinycolor(THEME.background).lighten(THEME.lightenRate).toHexString(),
      dropdown: THEME.dropdown,
      light: THEME.backgroundLight,
      dark: THEME.backgroundDark,
      search: THEME.search,
      action: THEME.action,
      change: THEME.change,
    },
    text: {
      primary: THEME.textPrimary,
      secondary: THEME.textSecondary,
      hint: '#B9B9B9',
      warning: 'rgba(255, 225, 0, .1)'
    },
  },
  paperShadows: {
    elevation2: THEME.elevation2,
    elevation3: THEME.elevation3,
    rowHoverShadow: THEME.rowHoverShadow,
    elevation6: THEME.elevation6,
    darkOnlyElevation2: THEME.darkOnlyElevation2,
    darkOnlyElevation3: THEME.darkOnlyElevation3,
    lightOnlyElevation2: THEME.lightOnlyElevation2,
  },
  typography: {
    fontFamily: `'Lato', sans-serif`,
    h1: { fontSize: '3rem' },
    h2: { fontSize: '2rem' },
    h3: { fontSize: '1.64rem' },
    h4: { fontSize: '1.5rem' },
    h5: { fontSize: '1.285rem' },
    h6: { fontSize: '1.142rem' },
    body1: { fontWeight: '300' },
  },
  customShadows: {
    widget: '0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
    widgetDark: '0px 3px 18px 0px #4558A3B3, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
    widgetWide: '0px 12px 33px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
  },
  overrides: {
    MuiIconButton: {
      root: {
        color: THEME.textSecondary,
        '&:hover': {
          backgroundColor: THEME.secondary,
        },
      },
    },

    MuiAlert: {
      root: {
        boxShadow: THEME.darkOnlyElevation3,
      },
      filledError: {
        backgroundColor: THEME.error,
      },
      filledSuccess: {
        backgroundColor: THEME.success,
      },
    },
    MuiContainer: {
      maxWidthSm: {
        maxWidth: '750px !important',
      },
    },
    MuiSvgIcon: {
      root: {
        fontSize: '1.125rem',
      },
    },
    MuiGrid: {
      item: {},
    },
    MuiTextField: {
      root: {},
    },
    MuiInput: {
      underline: {
        // paddingLeft: 14,
        paddingRight: 14,
        border: '1px solid ' + THEME.borderColor,
        borderRadius: '50px',

        '&:after': {
          content: 'none',
        },
        '&:before': {
          borderBottom: 'none !important',
          content: 'none',
        },
        '&.Mui-error .MuiOutlinedInput-notchedOutline': {
          borderColor: tinycolor(THEME.error).lighten(THEME.lightenRate).toHexString(),
        },
        '&.Mui-disabled': {
          borderColor: THEME.secondary + ' !important',
        },
        '&.Mui-disabled:hover': {
          borderColor: THEME.secondary + ' !important',
        },
        '&:hover': {
          borderColor: THEME.textSecondary + ' !important',
        },
        '&.Mui-focused': {
          borderColor: THEME.textLight + ' !important',
        },
      },
    },
    MuiInputBase: {
      root: {
        marginTop: 3,
        borderRadius: '25px',
        '&$disabled': {
          color: THEME.textPrimary,
        },
        color: THEME.textPrimary,
      },
      input: {
        marginLeft: 100,
        // TO DO 
        /* Change Autocomplete styles in Chrome*/
        // https://css-tricks.com/snippets/css/change-autocomplete-styles-webkit-browsers/"
        '&:-webkit-autofill, &:-webkit-autofill:focus, &:-webkit-autofill:hover, ': {
          // transitionDelay: '99999s',
          
          // thisPropos was causing problem in input password
          "-webkit-text-fill-color": THEME.textPrimary,
          backgroundColor: "0 0 0px 1000px " + THEME.search + " inset",
          transition: "background-color 5000s ease-in-out 0s",
        },
        // "&:-internal-autofill-selected": {
        //   boxShadow: "0 0 0px 1000px red inset"
        // },
        height: 'auto',
        fontSize: '0.85rem',
        paddingTop: '10px !important',
        paddingBottom: '10px !important',
        //color: '#6D7084',
      },
    },
    MuiFormControlLabel: {
      label: {
        color: THEME.textSecondary,
        textTransform: 'none !important',
        fontWeight: '500 !important',
        fontSize: '.8rem !important',
        '&.Mui-disabled': {
          color: THEME.textSecondary + '77',
        },
      },
      root: {
        marginLeft: 0,
      },
    },
    MuiFormGroup: {
      root: {
        position: 'relative',
      },
    },
    MuiFormHelperText: {
      root: {
        fontSize: '.65rem',
        '&:before': {
          content: "''",
          display: 'block',
          width: 0,
          height: 0,
          position: 'absolute',
          borderLeft: '4px solid transparent',
          borderBottom: '4px solid ' + THEME.error,
          borderRight: '4px solid transparent',
          left: 'calc(20% - 4px)',
          top: -4,
          zIndex: 999,
        },
        '&.Mui-error': {
          position: 'absolute',
          top: 46,
          left: 12,
          marginLeft: 'auto',
          backgroundColor: THEME.error,
          //  color: THEME.textPrimary,
          color: THEME.textError,
          display: 'inline-block !important',
          boxShadow: '0 0 3px 0 #0003',
          borderRadius: 25,
          paddingLeft: 8,
          paddingRight: 8,
          zIndex: 999,
        },
      },
    },
    MuiToolbar: {
      regular: {
        minHeight: 'auto !important',
        [bp.up('md')]: {
          height: 48,
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: '25px',
        '& fieldset': {
          overflow: 'hidden',
        },
        '&.Mui-error .MuiOutlinedInput-notchedOutline': {
          borderColor: tinycolor(THEME.error).lighten(THEME.lightenRate).toHexString(),
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderWidth: 1,
          borderColor: THEME.textSecondary,
        },
        '&.Mui-disabled': {
          color: THEME.textSecondary + '77',
        },
        '&.Mui-disabled fieldset': {
          borderColor: THEME.borderColor + ' !important',
        },
        '&.Mui-disabled:hover fieldset': {
          borderColor: THEME.borderColor + ' !important',
        },
        '&:hover fieldset': {
          borderColor: THEME.textSecondary + ' !important',
        },
        '&.Mui-focused fieldset': {
          borderColor: THEME.textLight + ' !important',
        },
      },

      notchedOutline: {
        // zIndex: 1301,
        borderColor: THEME.borderColor,
        // borderRadius: '50px',
      },
    },

    MuiBadge: {},
    MuiBackdrop: {
      root: {
        backgroundColor: '#4A4A4A1A',
      },
    },

    MuiMenu: {
      paper: {
        boxShadow: THEME.elevation3,
      },
    },
    MuiMenuItem: {},
    MuiCheckbox: {
      root: {
        color: THEME.textSecondary,
      },
    },

    MuiSelect: {
      selectMenu: {
        '& em': { color: '#6D7084' },
      },
      root: {
        textTransform: 'none',
        fontWeight: '300',
        fontSize: '.85rem',
      },
      icon: {
        color: THEME.textSecondary,
        top: 'calc(50% - 8.5px)',
      },
      iconOutlined: {
        right: 11,
      },
    },
    MuiListItemIcon: {
      root: {
        marginLeft: 4,
        minWidth: 'auto',
      },
    },
    MuiListItem: {
      root: {
        '&.Mui-selected': {
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
      },
      button: {
        '&:hover, &:focus': {
          background: 'transparent',
        },
      },
    },
    MuiTouchRipple: {
      child: {
        backgroundColor: THEME.secondary,
      },
    },
    MuiTableRow: {
      root: {
        transform: 'scale(1)',
      },
      hover: {
        transform: 'scale(1)',
        transition: 'all .1s',

        '&:hover': {
          // "& td:first-child": {
          //   "&:before": {
          //     position: "absolute",
          //     content: '""',
          //     left: ".4%",
          //     top: 0,
          //     marginTop: 3,
          //     width: "99.2%",
          //     height: "calc(100% - 6px)",
          //     backgroundColor: "transparent",
          //     boxShadow: THEME.elevation3,
          //     borderRadius: 4,
          //   },
          // },
          boxShadow: THEME.rowHoverShadow,
          cursor: 'pointer',
          background: THEME.selected + ' !important',
        },
      },
    },
    MuiTableCell: {
      root: {
        fontFamily: `'Lato', sans-serif`,
        fontWeight: '400',
        borderBottom: 'none',
      },
      head: {
        color: THEME.textSecondary,
        paddingTop: 4,
        paddingBottom: 4,
        backgroundColor: THEME.selected + '45',
        fontSize: '0.9rem',
      },
      body: {
        fontSize: '0.75rem',
        paddingTop: 9,
        paddingBottom: 9,
        fontWeight: 400,
      },
    },
    MuiPaper: {
      root: {
        backgroundColor: THEME.background,
      },
      rounded: {
        backgroundColor: THEME.background,
      },
      elevation3: {
        boxShadow: THEME.elevation3,
      },
      elevation2: {
        boxShadow: THEME.elevation2,
      },
    },
    MuiButtonBase: {
      root: {
        fontFamily: `'Lato', sans-serif`,
        textTransform: 'none !important',
        fontWeight: '600 !important',
        fontSize: '.75rem !important',
      },
    },
    MuiFab: {
      root: {},

      extended: {
        minWidth: '140px !important',
        padding: '14px 20px',
        [bp.down('sm')]: {
          padding: 13,
          minWidth: 'auto !important',
        },
      },
    },
    MuiButton: {
      root: {
        minWidth: '140px !important',
        [bp.down('sm')]: {
          minWidth: 'auto !important',
        },
      },
      text: {
        padding: '11px 21px',
        [bp.down('sm')]: {
          padding: '11px 5px',
        },
      },
      outlinedPrimary: {
        borderRadius: 25,
      },
      contained: {
        '&$disabled': {
          color: THEME.textPrimary + '44',
        },
      },
    },
    MuiPaginationItem: {
      root: {
        fontSize: '.75rem !important',
        height: 22,
        minWidth: 22,
        lineHeight: '22px',
        paddingTop: -1,
      },
      icon: {
        fontSize: '.9rem',
      },
    },
    MuiInputLabel: {
      root: {
        fontSize: '1.2rem',
        fontWeight: 600,
        color: THEME.textSecondary,
      },
    },
    MuiDrawer: {
      paper: {
        justifyContent: 'space-between',
        paddingBottom: '80px',
        overflowY: 'hidden',
      },
    },
    
    MuiLinearProgress:{
        colorPrimary: {
          backgroundColor: THEME.textPrimary,
      } 
    }
  },
});

export default makeTheme;
